const COOKIE_NAME = 'preferredLanguage';
const COOKIE_MAX_AGE = 31536000;
const LANGUAGES = ['de', 'en', 'fr', 'it'];
const DEFAULT_LANGUAGE = 'de';

const languagesMenu = document.querySelectorAll('.languages');

if (languagesMenu) {
    languagesMenu.forEach((item) => {
        item.addEventListener('click', function (event) {
            const languageItem = event.target.closest('.language-item');
            if (languageItem) {
                const language = languageFromHref(languageItem.getAttribute('href'));
                if (language) {
                    setPreferredLanguageCookie(language);
                }
            }
            item.classList.toggle('show');
        });
    });
}

function languageFromHref(href) {
    if (!href) {
        return null;
    }

    try {
        const first = new URL(href, window.location.origin).pathname.split('/').filter(Boolean)[0] || '';
        if (LANGUAGES.includes(first)) {
            return first;
        }
        return DEFAULT_LANGUAGE;
    } catch (error) {
        return null;
    }
}

function setPreferredLanguageCookie(language) {
    document.cookie = `${COOKIE_NAME}=${language}; Path=/; Max-Age=${COOKIE_MAX_AGE}; Secure; SameSite=Lax`;
}
